module.exports = __webpack_public_path__ + "static/media/stats.7f392816.svg";